import MosaicRule from "@arcgis/core/layers/support/MosaicRule";
import ImageryLayer from "@arcgis/core/layers/ImageryLayer";
import Query from "@arcgis/core/rest/support/Query";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { observerAddToHandles } from "../../../handles/Handles";
import { colorize } from "./imageryBandColor";
import MapView from "@arcgis/core/views/MapView";


export const addImagerytoView = (view:MapView,layerIds)=>{
  const {parcelMaps,tractMaps,parcels,recordsOfSurvey} = layerIds
  const whereClause = "OBJECTID=0";
  var rgbAM = { R: 252, G: 169, B: 2 };
  var rgbTR = { R: 252, G: 169, B: 2 };
  var rgbPM = { R: 252, G: 169, B: 2 };
  var rgbRS = { R: 252, G: 169, B: 2 };

  function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          R: parseInt(result[1], 16),
          G: parseInt(result[2], 16),
          B: parseInt(result[3], 16),
        }
      : null;
  }

  const mapId = view.map["portalItem"].id;
  if (localStorage.getItem(`legalLotImages-${mapId}`)) {
    rgbAM = hexToRgb(localStorage.getItem(`legalLotImages-${mapId}`));
  }

  if (localStorage.getItem(`ParcelMapsImages-${mapId}`)) {
    rgbPM = hexToRgb(localStorage.getItem(`ParcelMapsImages-${mapId}`));
  }

  if (localStorage.getItem(`RecordsofSurveyImages-${mapId}`)) {
    rgbRS = hexToRgb(localStorage.getItem(`RecordsofSurveyImages-${mapId}`));
  }

  if (localStorage.getItem(`TractMapsImage-${mapId}`)) {
    rgbTR = hexToRgb(localStorage.getItem(`TractMapsImage-${mapId}`));
  }

  const mosaicRule = new MosaicRule({
    ascending: true,
    method: "center",
    operation: "first",
    where: whereClause,
  });

  const parcelMapsImg = new ImageryLayer({
    id: "ParcelMapsImages",
    name: "ParcelMaps_Images",
    url: "https://www.ocgis.com/survey/rest/services/OCLandInsights/ParcelMap_Images/ImageServer",
    mosaicRule: mosaicRule,
    opacity: 0.7,
    noData: 1,
    //listMode: 'hide',
    pixelFilter: (e) => colorize(e, rgbPM),
    relatedFeatureLayerName: parcelMaps,
    relatedFeatureLayerAttribute: "Name",
  } as any);

  const tractMapsImg = new ImageryLayer({
    id: "TractMapsImage",
    name: "TractMaps_Images",
    url: "https://www.ocgis.com/survey/rest/services/OCLandInsights/TractMap_Images/ImageServer",
    mosaicRule: mosaicRule,
    opacity: 0.7,
    noData: 1,
    //listMode: 'hide',
    pixelFilter: (e) => colorize(e, rgbTR),
    relatedFeatureLayerName: tractMaps,
    relatedFeatureLayerAttribute: "Name",
  } as any);

  const rsMapsImg = new ImageryLayer({
    id: "RecordsofSurveyImages",
    name: "RSMaps_Images",
    url: "https://www.ocgis.com/survey/rest/services/OCLandInsights/RSMap_Images/ImageServer",
    mosaicRule: mosaicRule,
    opacity: 0.7,
    noData: 1,
    //listMode: 'hide',
    pixelFilter: (e) => colorize(e, rgbRS),
    relatedFeatureLayerName: recordsOfSurvey,
    relatedFeatureLayerAttribute: "BPNum",
  } as any);

  const legalLotMapsImg = new ImageryLayer({
    id: "legalLotImages",
    name: "legalLot_Images",
    url: "https://www.ocgis.com/arcpub/rest/services/ImageServices/AssessorMaps_Images/ImageServer",
    mosaicRule: mosaicRule,
    opacity: 0.7,
    noData: 1,
    //listMode: 'hide',
    pixelFilter: (e) => colorize(e, rgbAM),
    relatedFeatureLayerName: parcels,
    relatedFeatureLayerAttribute: "AssessmentNo",
  } as any);
  view.map.addMany([rsMapsImg, tractMapsImg, parcelMapsImg, legalLotMapsImg]);
  return [rsMapsImg, tractMapsImg, parcelMapsImg, legalLotMapsImg];
};

export const getRelatedImageryListFromSelectedFeature = (view,e,layerIds): Promise<any> => {
  const {tractMaps,parcels,parcelMaps,recordsOfSurvey}=layerIds
  if (e?.layer) {
    let title="";
    if (e?.parentCustomParameters?.OCLandInsightsID) {
      title = e?.parentCustomParameters?.OCLandInsightsID;
    }
    if (e.layer.customParameters?.OCLandInsightsID) {
      title = e.layer.customParameters?.OCLandInsightsID;
    }
    if (
      title === tractMaps ||
      title === parcelMaps ||
      title === recordsOfSurvey||
      title === parcels
    ) {
      //return view.when((view) => {
        const tractMapsImg=view.map.allLayers.find(layer=>layer.id==="TractMapsImage")
        const rsMapsImg=view.map.allLayers.find(layer=>layer.id==="RecordsofSurveyImages")
        const parcelMapsImg=view.map.allLayers.find(layer=>layer.id==="ParcelMapsImages")
        const legalLotsImg=view.map.allLayers.find(layer=>layer.id==="legalLotImages")
        
        let imageLayer;
        let assessNumber;
        if (title === tractMaps) {
          imageLayer = tractMapsImg;
        }
        if (title === recordsOfSurvey) {
          imageLayer = rsMapsImg;
        }
        if (title === parcelMaps) {
          imageLayer = parcelMapsImg;
        }
        if (title === parcels) {
          imageLayer = legalLotsImg;
          if(e.attributes[imageLayer.relatedFeatureLayerAttribute]){
            assessNumber=e.attributes[
              imageLayer.relatedFeatureLayerAttribute
            ].split("-")
            assessNumber=`${assessNumber[0]}${assessNumber[1].substring(0,2)}%`
          }
        }
        if (imageLayer) {
          let query = new Query({
            outFields: ["Name"],
            where: title===parcels?`Name like '${assessNumber}'`:`Name like '${e.attributes[
              imageLayer.relatedFeatureLayerAttribute
            ].replace("/", " ")}%'`,
          });
          return imageLayer
            .queryRasters(query)
            .then((res) => {
              const options = res.features.map(
                (feature) => feature.attributes.Name
              );
              return options;
            })
            .catch(() => []);
        }
        returnEmptyArrayPromise();
      //});
    }
    returnEmptyArrayPromise();
  }
  returnEmptyArrayPromise();
};

const returnEmptyArrayPromise = () => {
  return new Promise((resolve, reject) => {
    //return empty promise
    setTimeout(function () {
      resolve([]);
    });
  }).then((res) => res);
};

export const selectOnChange = (view, e: any, callback: any) => {
  const { selectedOptions } = e.target;
  if (selectedOptions) {
    let arr = Array.from(selectedOptions).map((option: any) => option.value);
    callback(arr);
    if (view.popup.selectedFeature) {
      let feat = view.popup.selectedFeature as any;
      let title = "";
      if (feat?.parentCustomParameters?.OCLandInsightsID as any) {
        title = feat?.parentCustomParameters?.OCLandInsightsID;
      }
      if (feat?.layer?.customParameters?.OCLandInsightsID) {
        title =
          view.popup.selectedFeature.layer.customParameters.OCLandInsightsID;
      }

      let imageLayer: any = view.map.allLayers
        .filter((lyr: any) => {
          return (
            lyr.type === "imagery" && lyr?.relatedFeatureLayerName === title
          );
        })
        .getItemAt(0);
      imageLayer.mosaicRule.where = `Name IN (${arr
        .map((item) => `'${item}'`)
        .toString()})`;
      imageLayer.refresh();
      imageLayer.visible = true;
    }
  }
};

export const clearImageryLayers = (layer) => {
  if (layer?.relatedFeatureLayerName && layer.type === "imagery") {
    layer.mosaicRule.where = "OBJECTID=-1";
    layer.visible = false;
  }
};

export const setObserverCallbacks = (view,setPayload,setSelect,layerIds) => {
  observerAddToHandles(
    reactiveUtils.watch(
      () => view.popup.selectedFeature,
      (e) => {
        setSelect([""]);
        setPayload([]);
        view.map.allLayers.forEach((layer: any) => {
          clearImageryLayers(layer);
        });
        getRelatedImageryListFromSelectedFeature(view,e,layerIds)?.then((res) =>
          setPayload(res)
        );
      }
    ),
    "docOverlayWidgetHandle"
  );
};
